import logo from "./logo.svg";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandngPage from "./pages/LandngPage";
import ContactUs from "./pages/ContactUs";
import WhyChooseUs from "./pages/WhyChooseUs";
import AboutUs from "./pages/AboutUs";
import SearchEngineOptimization from "./pages/SearchEngineOptimization";
import AnswerEngineOptimization from "./pages/AnswerEngineOptimization";
import GeographicalSeo from "./pages/GeographicalSeo";
import DigitalMarketingSolutions from "./pages/DigitalMarketingSolutions";



function App() {
  return (
    <BrowserRouter>
      {/* Routes */}
      <Routes>
        <Route path="/" element={<LandngPage />} />
	   <Route path="/why-choose-us" element={<WhyChooseUs />} />
	   <Route path="/about-us" element={<AboutUs />} />
	  <Route path="/search-engine-optimization" element={<SearchEngineOptimization />} />
	  <Route path="/answer-engine-optimization" element={<AnswerEngineOptimization />} />
	   <Route path="/Geographical-Seo" element={<GeographicalSeo />} />
	  <Route path="/Digital-Marketing-Solutions" element={<DigitalMarketingSolutions />} />
        <Route path="/ContactUs" element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
